import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserLink from './UserLink';
import UserLinkPopover from './UserLinkPopover';
import { isGroup } from '../helpers';
export const UserLinkWithTooltip = (_param)=>{
    var { user, className, contentClassName, biData, relatedItemBiData, withTooltip } = _param, props = _object_without_properties(_param, [
        "user",
        "className",
        "contentClassName",
        "biData",
        "relatedItemBiData",
        "withTooltip"
    ]);
    const isMobile = useContext(MobileContext);
    // in some cases this could be null, example deviation.author
    if (!user) {
        return null;
    }
    const shouldRenderTooltip = withTooltip && !isMobile && !isGroup(user);
    if (!shouldRenderTooltip) {
        return /*#__PURE__*/ React.createElement(UserLink, _object_spread({
            user: user,
            className: classnames(className, contentClassName),
            biData: biData
        }, props));
    }
    return /*#__PURE__*/ React.createElement(UserLinkPopover, {
        user: user,
        className: className,
        relatedItemBiData: relatedItemBiData,
        biData: biData
    }, /*#__PURE__*/ React.createElement(UserLink, _object_spread({
        user: user,
        className: contentClassName
    }, props)));
};
UserLinkWithTooltip.displayName = 'UserLinkWithTooltip';
export default UserLinkWithTooltip;

//# sourceMappingURL=UserLinkWithTooltip.js.map